import { Input } from "antd"
import { Field, FieldProps, useFormikContext } from "formik"
import useNoInitialEffect from "hooks/useNoInitialEffect"
import React, { useRef, useEffect, useState } from "react"
import { delayFunction } from "utils/functions"
const { Search } = Input

const DEFAULT_STYLE = {
  width: '100%'
}

interface SearchFieldProps extends React.ComponentProps<typeof Search> {
  name: string
}

const SearchField = (props: SearchFieldProps) => {
  const {
    name
  } = props

  const formik = useFormikContext()

  const field = formik.getFieldProps(name)

  // Make 100% width default
  const style = { ...DEFAULT_STYLE, ...props.style }

  const [inputValue, setInputValue] = useState(field.value)

  useEffect(() => {
    if (inputValue !== field.value) {
      setInputValue(field.value)
    }
  }, [field.value])

  useNoInitialEffect(() => {
    if (inputValue != props.value) {
      delayFunction('search-filter', () => {
        // Direct formik field handling
        formik.setFieldValue(name, inputValue)
      }, 500)
    }
  }, [inputValue])

  return (
    <Search
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      onSearch={(val) => formik.setFieldValue(field.name, inputValue)}

      {...props}

      style={style}
    />
  )
}

export default SearchField